import RenderWithRole from '../../../../hoc/renderWithRole';
import TeacherDashboard from '../TeacherDashboard/TeacherDashboard';
import StudentDashboard from '../StudentDashboard';

export default ({ history }) => {
  return RenderWithRole({
    teacher: <TeacherDashboard history={history} />,
    student: <StudentDashboard />,
  });
};
